module.exports = __webpack_public_path__ + "img/Header Logo.e686a3d9.png";